import { authHeader } from '../helpers';
import {defineConfig} from '../config'
import { utilsService } from './utils';
const {handleResponse} = utilsService;

export const campaignService = {
  getApiPath,
  getAllCampaigns,
  getAllCampaignsNoParams,
  getCampaignById,
  deleteCampaign,
  getAllCampaignsByOrderId,
  getAllByStrategyId,
  createCampaignForStrategy,
  updateCampaignForStrategy,
};

const {apiUrl, apiVer} = defineConfig.CAMPAIGN_SERVICE

function getApiPath(){
  return (apiUrl + apiVer + "/campaign")
}

function getAllCampaignsNoParams() {
  const url = getApiPath() + "/all"

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllCampaigns(campaignType = "OOH", sortType = "descend", sortValue = "", filters = {}, page = 0, perPage = 10) {
  let hasMultiType = false;

  const filterParams = Object.entries(filters)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => {
      if (key === "type" && campaignType === "ALL") {
        hasMultiType = true;
      }

      const encodedValue = Array.isArray(value)
        ? encodeURIComponent(value.join(','))
        : encodeURIComponent(value);

      return `${key}=${encodedValue}`;
    })
    .join('&');

  const typeParam = !hasMultiType ? `type=${encodeURIComponent(campaignType)}` : "";

  const queryParts = [
    typeParam,
    filterParams
  ].filter(Boolean).join('&');

  const url = `${getApiPath()}/all/${page}/${perPage}/${sortValue || "createDate"}/${sortType}?${queryParts}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => res);
}


function getCampaignById(id) {
  const url = getApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteCampaign(id) {
  const url = getApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllCampaignsByOrderId(orderId) {
  const url =  getApiPath() + "/all/order/" + orderId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllByStrategyId (strategyId) {
  const url = getApiPath() + "/all/strategy/" + strategyId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createCampaignForStrategy (strategyId, body) {
  const url = getApiPath() + `/create/strategy/${strategyId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateCampaignForStrategy (strategyId, body) {
  const url = apiUrl+apiVer+`/update/strategy/${strategyId}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}
